import MileageDownloadAllCSVRequest, {
  MileageDownloadAllCSVRequestOrder,
  MileageDownloadAllCSVRequestState,
  MileageDownloadAllCSVRequestVehicleType,
} from "../../../api/raily/mileage/download-all-csv/mileage-download-all-csv.request";
import MileageDownloadAllCSVParams, {
  MileageDownloadAllCSVParamsOrder,
  MileageDownloadAllCSVParamsState,
  MileageDownloadAllCSVParamsVehicleType,
} from "./mileage-download-all-csv-params";

const createOrder = (
  order?: MileageDownloadAllCSVParamsOrder | undefined,
): MileageDownloadAllCSVRequestOrder | undefined => {
  switch (order) {
    case MileageDownloadAllCSVParamsOrder.CARD_NO_ASC:
      return MileageDownloadAllCSVRequestOrder.CARD_NO_ASC;
    case MileageDownloadAllCSVParamsOrder.CARD_NO_DESC:
      return MileageDownloadAllCSVRequestOrder.CARD_NO_DESC;
    case MileageDownloadAllCSVParamsOrder.DATE_ASC:
      return MileageDownloadAllCSVRequestOrder.DATE_ASC;
    case MileageDownloadAllCSVParamsOrder.DATE_DESC:
      return MileageDownloadAllCSVRequestOrder.DATE_DESC;
    case MileageDownloadAllCSVParamsOrder.DISTANCE_ASC:
      return MileageDownloadAllCSVRequestOrder.DISTANCE_ASC;
    case MileageDownloadAllCSVParamsOrder.DISTANCE_DESC:
      return MileageDownloadAllCSVRequestOrder.DISTANCE_DESC;
    case MileageDownloadAllCSVParamsOrder.HUMAN_ID_ASC:
      return MileageDownloadAllCSVRequestOrder.HUMAN_ID_ASC;
    case MileageDownloadAllCSVParamsOrder.HUMAN_ID_DESC:
      return MileageDownloadAllCSVRequestOrder.HUMAN_ID_DESC;
    case MileageDownloadAllCSVParamsOrder.WORKER_NAME_ASC:
      return MileageDownloadAllCSVRequestOrder.WORKER_NAME_ASC;
    case MileageDownloadAllCSVParamsOrder.WORKER_NAME_DESC:
      return MileageDownloadAllCSVRequestOrder.WORKER_NAME_DESC;
    case MileageDownloadAllCSVParamsOrder.CARGO_COMPANY_NAME_ASC:
      return MileageDownloadAllCSVRequestOrder.CARGO_COMPANY_NAME_ASC;
    case MileageDownloadAllCSVParamsOrder.CARGO_COMPANY_NAME_DESC:
      return MileageDownloadAllCSVRequestOrder.CARGO_COMPANY_NAME_DESC;
    case MileageDownloadAllCSVParamsOrder.WORKER_LAST_NAME_ASC:
      return MileageDownloadAllCSVRequestOrder.WORKER_LAST_NAME_ASC;
    case MileageDownloadAllCSVParamsOrder.WORKER_LAST_NAME_DESC:
      return MileageDownloadAllCSVRequestOrder.WORKER_LAST_NAME_DESC;
    default:
      return undefined;
  }
};

const createVehicleType = (
  type: MileageDownloadAllCSVParamsVehicleType | undefined,
): MileageDownloadAllCSVRequestVehicleType | undefined => {
  switch (type) {
    case MileageDownloadAllCSVParamsVehicleType.CAR_GT_900CM3:
      return MileageDownloadAllCSVRequestVehicleType.CAR_GT_900CM3;
    case MileageDownloadAllCSVParamsVehicleType.CAR_LE_900CM3:
      return MileageDownloadAllCSVRequestVehicleType.CAR_LE_900CM3;
    case MileageDownloadAllCSVParamsVehicleType.COMPANY_OWNED:
      return MileageDownloadAllCSVRequestVehicleType.COMPANY_OWNED;
    case MileageDownloadAllCSVParamsVehicleType.MOPED:
      return MileageDownloadAllCSVRequestVehicleType.MOPED;
    case MileageDownloadAllCSVParamsVehicleType.MOTORCYCLE:
      return MileageDownloadAllCSVRequestVehicleType.MOTORCYCLE;
    default:
      return undefined;
  }
};

const createState = (
  state: MileageDownloadAllCSVParamsState | undefined,
): MileageDownloadAllCSVRequestState | undefined => {
  switch (state) {
    case MileageDownloadAllCSVParamsState.ACCEPTED:
      return MileageDownloadAllCSVRequestState.ACCEPTED;
    case MileageDownloadAllCSVParamsState.DELEGATION_CREATED:
      return MileageDownloadAllCSVRequestState.DELEGATION_CREATED;
    case MileageDownloadAllCSVParamsState.PENDING:
      return MileageDownloadAllCSVRequestState.PENDING;
    case MileageDownloadAllCSVParamsState.REJECTED:
      return MileageDownloadAllCSVRequestState.REJECTED;
  }
};

const create = (
  params: MileageDownloadAllCSVParams,
): MileageDownloadAllCSVRequest => {
  return {
    address: params.address,
    card_number: params.cardNumber,
    company_id: params.companyId,
    date_since: params.dateSince?.toISOString(),
    date_to: params.dateTo?.toISOString(),
    distance_max: params.distanceMax,
    distance_min: params.distanceMin,
    end_address: params.endAddress,
    cargo_company_name: params.cargoCompanyName,
    human_id: params.humanId,
    mid_address: params.midAddress,
    mileage_number: params.mileageNumber,
    order: createOrder(params.order),
    start_address: params.startAddress,
    worker_name: params.workerName,
    vehicle_type: createVehicleType(params.vehicleType),
    state: createState(params.state),
  };
};

const mileageDownloadAllCSVRequestFactory = {
  create,
};

export default mileageDownloadAllCSVRequestFactory;
